import React from "react";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Collapse,
  IconButton,
  Typography,
} from "@mui/material";
import { useState } from "react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import moment from "moment";
import CallIcon from "@mui/icons-material/Call";
import { useNavigate } from "react-router-dom";

function NotConnectedCallTable({ callData }) {
  const [page, setPage] = useState(0); // Current page
  const [rowsPerPage, setRowsPerPage] = useState(5); // Rows per page
  const [openRows, setOpenRows] = useState([]); // To manage which rows are expanded

  const navigate = useNavigate();

  // Handle page change
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  // Handle rows per page change
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0); // Reset to the first page
  };

  // Handle row expansion toggle
  const handleRowToggle = (index) => {
    setOpenRows((prev) => {
      if (prev.includes(index)) {
        return prev.filter((rowIndex) => rowIndex !== index);
      } else {
        return [...prev, index];
      }
    });
  };

  const formatDate = (dateString) =>
    moment(dateString).format("DD-MM-YYYY HH:mm:ss");

  const IconCell = ({ row }) => (
    <>
      <IconButton
        style={{
          border: "1px solid",
          borderRadius: "4px",
          padding: "2px",
          width: "24px",
          height: "24px",
          justifyContent: "center",
          alignItems: "center",
        }}
        color="primary"
        onClick={() => handleCallIconClick(row)}
      >
        <CallIcon fontSize="small" color="primary" />
      </IconButton>
    </>
  );

  const handleCallIconClick = (row) => {
    navigate("/dashboard", {
      state: {
        mobNo: row.caller_number,
      },
    });
  };

  return (
    <>
      <Paper>
        <TableContainer component={Paper} elevation={3}>
          <Table
            sx={{
              minWidth: 650,
              height: "100%",
              tableLayout: "fixed",
            }}
            aria-label="simple table"
          >
            <TableHead>
              <TableRow sx={{ backgroundColor: "#EEF0F4" }}>
                <TableCell width={50} sx={{ textAlign: "left" }} />
                <TableCell
                  width={50}
                  sx={{ fontWeight: "bold", textAlign: "center", padding: 1 }}
                >
                  SNo
                </TableCell>
                <TableCell
                  width={160}
                  sx={{ fontWeight: "bold", textAlign: "center", padding: 1 }}
                >
                  Customer Name
                </TableCell>
                <TableCell
                  width={150}
                  sx={{ fontWeight: "bold", textAlign: "center", padding: 1 }}
                >
                  Caller Number
                </TableCell>
                <TableCell
                  width={150}
                  sx={{ fontWeight: "bold", textAlign: "center", padding: 1 }}
                >
                  Connected At
                </TableCell>
                <TableCell
                  width={120}
                  sx={{ fontWeight: "bold", textAlign: "center", padding: 1 }}
                >
                  Ended At
                </TableCell>
                <TableCell
                  width={120}
                  sx={{ fontWeight: "bold", textAlign: "center", padding: 1 }}
                >
                  Duration (Minutes)
                </TableCell>
                {localStorage.getItem("empRole") === "1" && (
                  <TableCell
                    width={120}
                    sx={{ fontWeight: "bold", textAlign: "center", padding: 1 }}
                  >
                    Action
                  </TableCell>
                )}
              </TableRow>
            </TableHead>
            <TableBody>
              {callData.length > 0 ? (
                callData
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((row, rowIndex) => (
                    <React.Fragment key={rowIndex}>
                      <TableRow
                        sx={{
                          "&:hover": { backgroundColor: "#f9f9f9" },
                        }}
                      >
                        <TableCell>
                          <IconButton
                            onClick={() => handleRowToggle(rowIndex)}
                            sx={{ padding: 0 }}
                          >
                            <ExpandMoreIcon />
                          </IconButton>
                        </TableCell>
                        <TableCell width={50} sx={{ textAlign: "center" }}>
                          {page * rowsPerPage + rowIndex + 1}
                        </TableCell>
                        <TableCell width={160} sx={{ textAlign: "center" }}>
                        {row.customer_details === null
                            ? "New Customer"
                            : row.customer_details?.customer_name}
                        </TableCell>
                        <TableCell width={150} sx={{ textAlign: "center" }}>
                          {row.caller_number || "-"}
                        </TableCell>
                        <TableCell width={150} sx={{ textAlign: "center" }}>
                          {row.connected_at || "-"}
                        </TableCell>
                        <TableCell width={120} sx={{ textAlign: "center" }}>
                          {row.ended_at || "-"}
                        </TableCell>
                        <TableCell
                          width={120}
                          sx={{
                            textAlign: "center",
                            textTransform: "capitalize",
                          }}
                        >
                          {row.duration_minutes || "-"}
                        </TableCell>
                        {localStorage.getItem("empRole") === "1" && (
                          <TableCell
                            width={120}
                            sx={{
                              textAlign: "center",
                            }}
                          >
                            <IconCell row={row} />
                          </TableCell>
                        )}
                      </TableRow>
                      <TableRow>
                        <TableCell
                          colSpan={7}
                          sx={{ paddingBottom: 0, paddingTop: 0 }}
                        >
                          <Collapse
                            in={openRows.includes(rowIndex)}
                            timeout="auto"
                            unmountOnExit
                          >
                            <Paper sx={{ padding: 2 }}>
                              <Typography variant="h6">
                                Customer Details
                              </Typography>
                              <Typography>
                                <strong>Customer Name:</strong>{" "}
                                {row.customer_details?.customer_name || "-"}
                              </Typography>
                              <Typography>
                                <strong>Location:</strong>{" "}
                                {row.customer_details?.lot_number || "-"}
                              </Typography>
                            </Paper>
                          </Collapse>
                        </TableCell>
                      </TableRow>
                    </React.Fragment>
                  ))
              ) : (
                <TableRow>
                  <TableCell colSpan={8} align="center">
                    No details yet
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[5, 10, 25]} // Options for rows per page
          component="div"
          count={callData.length} // Total number of rows
          rowsPerPage={rowsPerPage} // Current rows per page
          page={page} // Current page
          onPageChange={handleChangePage} // Handle page change
          onRowsPerPageChange={handleChangeRowsPerPage} // Handle rows per page change
        />
      </Paper>
    </>
  );
}

export default NotConnectedCallTable;
